import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Navbar, Nav, NavDropdown, Container, Button } from "react-bootstrap";

import * as UserActions from '../../../redux/user/actions';
import  '../../Styles/css/home.css'; 

class Header extends Component {


    render() {
        const navs = [
            /*Comments: Code commented for submenu of submenu*/
            /*{
                label: "Home",
                url: "/"
            },
            {
                label: "Insights",  //Changed from Verticals to Insights
                url: "/offerings"
            },
            */  
                
            {
                label: "News",   
                url: "/news"  
            },
            {
                label: "Support",
                subs: [
                    /*{ label: "5G Resources", url: "/resources" },*/ /*commented 5G Resources menu*/
                    { label: "Contact Us", url: "/contact" }
                ]
            },
            {
                label: "Login",   
                url: "/login"  
            }
        ] 
       
        if(typeof(this.props.user.name) == 'undefined' || this.props.user.name == null || this.props.user.name == "")
        {       
            // Nothing
        }else{
            navs.splice(2, 1);
        }

        const mainLinks = navs.map(link => {
            if (link.subs !== undefined) {
                return (
                    <NavDropdown  key={link.label} title={link.label} alignRight className="whitemenu">
                        {link.subs.map(function (val, i) {
                            return  <NavDropdown.Item  key={`${link.label}_sub_${i}`} href={val.url}>{val.label}</NavDropdown.Item>;
                        })}
                    </NavDropdown>
                )
            }
            return (
                <Nav.Link key={link.label} style={{color:'white'}}  className={window.location.pathname == link.url ? 'active' : ''} href={link.url}>{link.label}</Nav.Link>
            )
        })

        const user  = this.props.user || null
        const showAdminDropdown = user.roles ? (user.roles.includes('administrator') || user.roles.includes('bmo')) : false
        
        const token=this.props.token?this.props.token:"";
        let dashboardUrl ="";
        if(token!==""){
            dashboardUrl= this.props.settings ? `${this.props.settings.ba_settingsSettingsBaDashboardDomain}/login?key=${token}` : "";
        }else{
            dashboardUrl= this.props.settings ? `${this.props.settings.ba_settingsSettingsBaDashboardDomain}` : "";
        }        
         
        
        if(typeof(this.props.user.name) == 'undefined' || this.props.user.name == null || this.props.user.name == "")
        {
            return (
                <Navbar bg="dark" variant="dark" expand="md">
                    <Container>
                        <Navbar.Brand href="/">
                            <img src="/assets/logo-white.svg" height="70" />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse>
                            <Nav className="ml-auto" style={{fontWeight:'bold'}}>
                                {
    
                                /*Comments: Code changes for submenu of submenu*/
                                <Nav.Link key="home_0" style={{color:'white'}}  href={"/"}>Home</Nav.Link>}
                                {
                                    <NavDropdown key="sales_0" href={""} className="whitemenu" title="Sales Resources">
                                    {
                                        <NavDropdown.Item key="saleskits_0"  href={"/products"}>Products</NavDropdown.Item>
                                    }
                                    {
                                        <NavDropdown.Item key="videos_0"  href={"/videos"}>Videos</NavDropdown.Item>
                                    }                                    
                                    </NavDropdown>
                                }
    
                                {mainLinks}     
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            )
        }else
        {
            return (
                <Navbar bg="dark" variant="dark" expand="md">
                    <Container>
                        <Navbar.Brand href="/">
                            <img src="/assets/logo-white.svg" height="70" />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse>
                            <Nav className="ml-auto" style={{fontWeight:'bold'}}>
                                {
    
                                /*Comments: Code changes for submenu of submenu*/
                                <Nav.Link key="home_0" style={{color:'white'}}  href={"/"}>Home</Nav.Link>}
                                {
                                    <NavDropdown key="sales_0" href={""} className="whitemenu" title="Sales Resources">
                                    {
                                        <NavDropdown.Item key="saleskits_0"  href={"/products"}>Products</NavDropdown.Item>
                                    }
                                    {
                                        <NavDropdown.Item key="videos_0"  href={"/videos"}>Videos</NavDropdown.Item>
                                    }
                                   {/* {
                                        <NavDropdown key="videos_0" href={""} className="blackmenu" title="Videos">
                                             {
                                                <NavDropdown.Item key="video_0"  href={""}>CPaaS Intro Video</NavDropdown.Item>
                                             }
                                             {
                                                <NavDropdown.Item key="video_1"  href={""}>CloudPBX</NavDropdown.Item>
                                             }
                                             {
                                                <NavDropdown.Item key="video_2"  href={""}>Contact Centre</NavDropdown.Item>
                                             }
                                              {
                                                <NavDropdown.Item key="video_3"  href={""}>UcaaS Connector</NavDropdown.Item>
                                             }
                                        </NavDropdown>
                                    }*/}
                                    </NavDropdown>
                                }
    
                                {mainLinks}
                                {/*<Nav.Link href="/search"><i style={{color:'white'}} className="icon-search"></i></Nav.Link>*/}
                                { showAdminDropdown && 
                                <NavDropdown alignRight className="whitemenu" title="Admin">
                                    <div className="p-3 mw-200">
                                        {
                                            this.props.user.roles.includes('bmo') &&
                                            <Button target="_blank" href={dashboardUrl} variant="primary" block>Submit Content</Button>
                                        }
                                        {
                                            this.props.user.roles.includes('administrator') &&
                                            <Button target="_blank" href={dashboardUrl} variant="outline-primary" block>Admin Login</Button>
                                        }
                                    </div>
                                </NavDropdown>
                                }
                                <NavDropdown  alignRight title={this.props.user.name} className="whitemenu" id="login-dropdown">
                                    <div className="p-3 mw-200">
                                        <Button variant="outline-primary" block onClick={this.props.userlogout}>Logout</Button>
                                    </div>
                                </NavDropdown>                            
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            )   
        }                             
    }
}

const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    user: state.user.user ? state.user.user : null,
    settings: state.app.settings,
    token:state.user.token?state.user.token:'',
});

// Any actions to map to the component?
const mapDispatchToProps = {
    userlogout: UserActions.logout
};

export default connect(mapStateToProps, mapDispatchToProps)(Header)